
import React from 'react';
import { Loader2 } from 'lucide-react';

const SIZES = {
  sm:  { icon: 16, text: 'text-xs' },
  md:  { icon: 28, text: 'text-sm' },
  lg:  { icon: 44, text: 'text-base' },
};

export default function LoadingSpinner({ size = 'md', message }) {
  const { icon, text } = SIZES[size] ?? SIZES.md;

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-12 select-none">
      <Loader2 size={icon} className="animate-spin text-amber-500" />
      {message && (
        <p className={`${text} text-gray-400 font-medium`}>{message}</p>
      )}
    </div>
  );
}
